module.exports = __webpack_public_path__ + "img/auth_code.e9bd2a13.png";